<div
  class="region-info"
  *ngIf="region(); else noRegion"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'"
  [ngStyle]="{color: region()?.color}">
  {{region()?.name}}
</div>

<ng-template #noRegion>
  <div class="no-region"></div>
</ng-template>

<ng-template #popover>
  <wr-region-popover [regionId]="region()?.id" [disableLink]="disableLink"></wr-region-popover>
</ng-template>
